import gsap from 'gsap';

export default function counsellorPage() {
    const url = location.pathname;

    const filterListWrapper = $('.filter-list-wrapper');
    const filterShowWrapper = $('.show-filters-items');
    const filterButtonWrapper = $('.show-filters-button-items');
    const regionItems = $('.counsellor-regions');
    const accTypesItems = $('.counsellor-acc-types');
    const specialitiesItems = $('.counsellor-specialities');
    const clearButton = $('.counsellors-clear-btn');
    const searchInputs = $('.counsellor-search-input');
    const searchButton = $('.counsellor-search-button');

    const showMoreRegionsButton = $('.region-show-more-button');
    const showMoreTypesButton = $('.type-show-more-button');
    const showMoreSpecialityButton = $('.speciality-show-more-button');

    const regionItemList = $('.region-list-items');
    const regionItemListDesktop = $('.region-list');
    const regionItemListMobile = $('.region-list-mobile');
    const typeItemList = $('.type-list-items');
    const typeItemListDesktop = $('.type-list');
    const typeItemListMobile = $('.type-list-mobile');
    const specialityItemList = $('.speciality-list-items');
    const specialityItemListDesktop = $('.speciality-list');
    const specialityItemListMobile = $('.speciality-list-mobile');

    FiltersInitialisation();
    DefaultFilters();

    InitiliaseButton(showMoreRegionsButton,regionItemList);
    InitiliaseButton(showMoreTypesButton,typeItemList);
    InitiliaseButton(showMoreSpecialityButton,specialityItemList);

    clearButton.each(function(){
        $(this).off('off').on('click touchstart', function() {
            clearFilters();
        });
    });

    function ToggleOptions(disabled){
        $('.counsellor-regions').each(function(){
            if(disabled){
                $(this).attr('disabled', 'disabled');
            } else {
                $(this).removeAttr('disabled')
            }
        });
        $('.counsellor-acc-types').each(function(){
            if(disabled){
                $(this).attr('disabled', 'disabled');
            } else {
                $(this).removeAttr('disabled')
            }
        });
        $('.counsellor-specialities').each(function(){
            if(disabled){
                $(this).attr('disabled', 'disabled');
            } else {
                $(this).removeAttr('disabled')
            }
        });
    }

    function clearFilters(){
        searchInputs.each(function(){
            $(this).val('');
        });
        $('.counsellor-regions:checked').each(function(){
            $(this).prop('checked', false);
        });
        $('.counsellor-acc-types:checked').each(function(){
            $(this).prop('checked', false);
        });
        $('.counsellor-specialities:checked').each(function(){
            $(this).prop('checked', false);
        });
        allRegionsCheck();
        clearButton.addClass('d-none');
        filterListWrapper.addClass('d-none');
        reloadCounsellors();
    }

    function collectAccTypes() {
        let accTypesArray = [];
        $('.counsellor-acc-types[data-type="mobile"]').each(function (){
            if($(this).prop('checked')){
                accTypesArray.push($(this).val());
            }
        });
        return accTypesArray;
    }

    function collectSpecialities() {
        let specialitiesArray = [];
        $('.counsellor-specialities[data-type="mobile"]').each(function (){
            if($(this).prop('checked')){
                specialitiesArray.push($(this).val());
            }
        });
        return specialitiesArray;
    }

    function collectFilters(){
        let hasFilters = false;
        let returnParameters = '';
        let filterList = [];

        searchInputs.each(function() {
            let searchSelected = $(this).val();
            if(searchSelected !== ''){
                filterList.push(FindItemToAddToFilterList(searchSelected,'Search'));
                searchSelected = encodeURIComponent(searchSelected);
                returnParameters = filterCleanText(returnParameters, 'Q', searchSelected, hasFilters);
                hasFilters = true;
                return false;
            }
        });

        let regionSelected = $('.counsellor-regions:checked');
        let regionSelectedValue = regionSelected.val();
        if(regionSelectedValue !== undefined){
            if(regionSelectedValue !== '*') {
                filterList.push(FindItemToAddToFilterList(regionSelectedValue,'Region'));
                regionSelectedValue = encodeURIComponent(regionSelectedValue);
                returnParameters = filterCleanText(returnParameters, 'Area', regionSelectedValue, hasFilters);
                hasFilters = true;
            }
        }

        let accTypeSelected = collectAccTypes();
        let accTypeSelectedText = accTypeSelected.join("|");
        if(accTypeSelectedText !== undefined){
            if(accTypeSelectedText !== ''){
                $.each(accTypeSelected, function (index, value){
                    filterList.push(FindItemToAddToFilterList(value,'Type'));
                });
                accTypeSelectedText = encodeURIComponent(accTypeSelectedText);
                returnParameters = filterCleanText(returnParameters, 'Profession', accTypeSelectedText, hasFilters);
                hasFilters = true;
            }
        }

        let specialitiesSelected = collectSpecialities();
        let specialitiesSelectedText = specialitiesSelected.join("|");
        if(specialitiesSelectedText !== undefined){
            if(specialitiesSelectedText !== ''){
                $.each(specialitiesSelected, function (index, value){
                    filterList.push(FindItemToAddToFilterList(value,'Speciality'));
                });
                specialitiesSelectedText = encodeURIComponent(specialitiesSelectedText);
                returnParameters = filterCleanText(returnParameters, 'Speciality', specialitiesSelectedText, hasFilters);
                hasFilters = true;
            }
        }

        if(filterList.length > 0){
            ReloadFilterList(filterList);
            ApplyClickOnFilters();
        } else {
            filterShowWrapper.html('');
            filterButtonWrapper.html('');
        }

        return (hasFilters) ? '?' + returnParameters : returnParameters;
    }

    function ApplyClickOnFilters(){
        $('.filter-item-list').each(function(){
            let item = $(this);
            item.on('click',function(){
                if(item.attr('data-filter') === 'search'){
                    searchInputs.each(function() {
                        $(this).val('');
                    });
                } else if (item.attr('data-filter') === 'specialities'){
                    $('.counsellor-specialities').each(function() {
                        let innerItem = $(this);
                        if(innerItem.attr('data-id') === item.attr('data-id')){
                            innerItem.prop('checked', false);
                        }
                    });
                } else if (item.attr('data-filter') === 'provider'){
                    $('.counsellor-acc-types').each(function() {
                        let innerItem = $(this);
                        if(innerItem.attr('data-id') === item.attr('data-id')){
                            innerItem.prop('checked', false);
                        }
                    });
                } else if (item.attr('data-filter') === 'region'){
                    $('.counsellor-regions').each(function() {
                        let innerItem = $(this);
                        if(innerItem.attr('data-id') === item.attr('data-id') && innerItem.attr('data-type') === 'mobile' ){
                            innerItem.prop('checked', false);
                        }
                        if(innerItem.attr('data-id') === item.attr('data-id') && innerItem.attr('data-type') === 'desktop' ){
                            innerItem.prop('checked', false);
                        }
                    });
                }
                let region = $('.counsellor-regions:checked').val();
                if(region === undefined){
                    allRegionsCheck();
                }
                checkWhetherOptionsEmpty();
                reloadCounsellors();
            });
        });
    }

    function ReloadFilterList(array){
        filterShowWrapper.html('');
        filterButtonWrapper.html('');
        if(array.length > 0){
            if(array.length === 1){
                filterShowWrapper.append('<h4>'+array.length+' Applied Filter</h4>');
            } else {
                filterShowWrapper.append('<h4>'+array.length+' Applied Filters</h4>');
            }

        }
        $.each(array,function (index,value){
            filterShowWrapper.append(value);
            filterButtonWrapper.append(value);
        });
    }

    function FindItemToAddToFilterList(val,type){
        let returnItem = '';
        let foundItem = null;
        if(type === 'Type'){
            $('.counsellor-acc-types').each(function (){
                let item = $(this);
                if(item.val() === val){
                    foundItem = item;
                }
            });
        } else if(type === 'Speciality'){
            $('.counsellor-specialities').each(function (){
                let item = $(this);
                if(item.val() === val){
                    foundItem = item;
                    return false;
                }
            });
        } else if(type === 'Region'){
            $('.counsellor-regions').each(function (){
                let item = $(this);
                if(item.val() === val){
                    foundItem = item;
                    return false;
                }
            });
        }

        if(type === 'Search'){
            returnItem = '<div class="filter-item-list" data-filter="search"><i class="fa-solid fa-circle-x"></i><span>Search: '+val+'</span></div>';
        } else {
            returnItem = '<div class="filter-item-list" data-filter="'+foundItem.attr('data-filter')+'" data-id="'+foundItem.attr('data-id')+'"><i class="fa-solid fa-circle-x"></i><span>'+val+'</span></div>';
        }

        return returnItem;
    }

    regionItems.on('change', function() {
        let item = $(this);
        let isChecked = item.is(':checked')
        let id = item.attr('data-id')
        if(item.attr('data-type') === 'desktop'){
            regionItems.each(function(){
                let innerMobile = $(this);
                if(innerMobile.attr('data-type') === 'mobile' && innerMobile.attr('data-id') === id){
                    innerMobile.prop('checked',isChecked);
                }
            });
        } else {
            regionItems.each(function(){
                let innerMobile = $(this);
                if(innerMobile.attr('data-type') === 'desktop' && innerMobile.attr('data-id') === id){
                    innerMobile.prop('checked',isChecked);
                }
            });
        }
        checkWhetherOptionsEmpty();
        reloadCounsellors();
    });

    accTypesItems.on('change', function() {
        scrollToDiv();
        let item = $(this);
        let isChecked = item.is(':checked')
        let id = item.attr('data-id')
        if(item.attr('data-type') === 'desktop'){
            accTypesItems.each(function(){
                let innerMobile = $(this);
                if(innerMobile.attr('data-type') === 'mobile' && innerMobile.attr('data-id') === id){
                    innerMobile.prop('checked',isChecked);
                }
            });
        } else {
            accTypesItems.each(function(){
                let innerMobile = $(this);
                if(innerMobile.attr('data-type') === 'desktop' && innerMobile.attr('data-id') === id){
                    innerMobile.prop('checked',isChecked);
                }
            });
        }
        checkWhetherOptionsEmpty();
        reloadCounsellors();
    });

    specialitiesItems.on('change', function() {
        scrollToDiv();
        let item = $(this);
        let isChecked = item.is(':checked')
        let id = item.attr('data-id')
        if(item.attr('data-type') === 'desktop'){
            specialitiesItems.each(function(){
                let innerMobile = $(this);
                if(innerMobile.attr('data-type') === 'mobile' && innerMobile.attr('data-id') === id){
                    innerMobile.prop('checked',isChecked);
                }
            });
        } else {
            specialitiesItems.each(function(){
                let innerMobile = $(this);
                if(innerMobile.attr('data-type') === 'desktop' && innerMobile.attr('data-id') === id){
                    innerMobile.prop('checked',isChecked);
                }
            });
        }
        checkWhetherOptionsEmpty();
        reloadCounsellors();
    });

    function handleSearchButtonClick() {
        checkWhetherOptionsEmpty();
        reloadCounsellors();
    }

    function scrollToDiv(){
        gsap.to(window, {
            duration: 0.2,
            scrollTo: { y: "#ServiceProviderSection", offsetY: 10 }, // scrolls to 50px above the element
            ease: "power4.out"
        });
    }

    searchButton.each(function() {
        $(this).on('click touchstart', handleSearchButtonClick);
    });

    searchInputs.each(function() {
        $(this).on('keyup', function(e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
                reloadCounsellors();
            }
        });

        $(this).on('input', function() {
            let value = $(this).val();
            searchInputs.val(value);
        });
    });

    function filterCleanText(currentParameters, variable, value, hasFilters){
        let variableText = (hasFilters) ? '&' : '';
        variableText += variable + '=' + value;
        return currentParameters + variableText;
    }

    function reloadCounsellors(){
        $('#CounsellorWrapper').html('');
        $('#CounsellorPagination').html('');
        $('#NoResultsMessage').addClass('d-none');
        let filters = collectFilters();
        if(filters !== ''){
            clearButton.removeClass('d-none');
            history.pushState(null, null, url + filters);
        } else {
            history.pushState(null, null, url);
        }

        ToggleOptions(true);
        $.ajax({
            type: "GET",
            url: url + filters,
            success: function(response) {
                var html = $(response);
                var resource_data = html.find('#CounsellorWrapper').children();
                var resource_pagination = html.find('#CounsellorPagination');
                if (resource_data.length > 0) {
                    $('#CounsellorWrapper').append(resource_data);
                    $('#CounsellorPagination').append(resource_pagination);
                } else {
                    $('#NoResultsMessage').removeClass('d-none');
                }
                ToggleOptions(false);
            },
            error: function() {
                console.log("There was an error");
                console.error();
            },
        });
    }

    function getParameterByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    function FiltersInitialisation(){
        let filterList = [];
        let filterRegion = getParameterByName('Area');
        let filterType = getParameterByName('Profession');
        let filterSpeciality = getParameterByName('Speciality');
        let filterSearch = getParameterByName('Q');

        if(filterSearch !== null || filterRegion !== null || filterType !== null || filterSpeciality !== null){
            clearButton.removeClass('d-none');
        }

        if(filterSearch !== null){
            searchInputs.val(filterSearch);
            filterList.push(FindItemToAddToFilterList(filterSearch,'Search'));
        }

        if(filterRegion !== null){
            $('.counsellor-regions[data-type="desktop"]').each(function(){
                let item = $(this);
                if(item.val() === filterRegion){
                    item.prop('checked', true);
                    filterList.push(FindItemToAddToFilterList(filterRegion,'Region'));
                }
            });
            $('.counsellor-regions[data-type="mobile"]').each(function(){
                let item = $(this);
                if(item.val() === filterRegion){
                    item.prop('checked', true);
                }
            });

        } else {
            allRegionsCheck();
        }

        if(filterType !== null){
            let filterTypeArray = filterType.split('|');
            $('.counsellor-acc-types[data-type="desktop"]').each(function(){
                let item = $(this);
                if($.inArray(item.val(),filterTypeArray) >= 0){
                    item.prop('checked', true);
                    filterList.push(FindItemToAddToFilterList(item.val(),'Type'));
                }
            });
            $('.counsellor-acc-types[data-type="mobile"]').each(function(){
                let item = $(this);
                if($.inArray(item.val(),filterTypeArray) >= 0){
                    item.prop('checked', true);
                }
            });
        }

        if(filterSpeciality !== null){
            let filterSpecialityArray = filterSpeciality.split('|');
            $('.counsellor-specialities[data-type="desktop"]').each(function(){
                let item = $(this);
                if($.inArray(item.val(),filterSpecialityArray) >= 0){
                    item.prop('checked', true);
                    filterList.push(FindItemToAddToFilterList(item.val(),'Speciality'));
                }
            });
            $('.counsellor-specialities[data-type="mobile"]').each(function(){
                let item = $(this);
                if($.inArray(item.val(),filterSpecialityArray) >= 0){
                    item.prop('checked', true);
                }
            });
        }

        checkWhetherOptionsEmpty();
        if(filterList.length > 0){
            ReloadFilterList(filterList);
            ApplyClickOnFilters();
        } else {
            filterShowWrapper.html('');
        }
    }

    function allRegionsCheck(){
        $('.counsellor-regions').each(function(){
            let item = $(this);
            if(item.val() === '*'){
                item.prop('checked', true);
            }
        });
    }

    function checkWhetherOptionsEmpty(){
        let hideResetButton = false;
        let region = $('.counsellor-regions:checked').val();
        if(region === '*'){
            hideResetButton = true;
        }

        let acc = collectAccTypes();
        if(acc.join("|") !== '' && hideResetButton){
            hideResetButton = false;
        }

        let speciality = collectSpecialities();
        if(speciality.join("|") !== '' && hideResetButton){
            hideResetButton = false;
        }

        let search = searchInputs.val();
        if(search !== '' && hideResetButton){
            hideResetButton = false;
        }

        if(hideResetButton){
            clearButton.each(function(){
                $(this).addClass('d-none');
            })
            filterListWrapper.addClass('d-none');
        } else {
            clearButton.each(function(){
                $(this).removeClass('d-none');
            })
            filterListWrapper.removeClass('d-none');
        }
    }

    function InitiliaseButton(button, items){
        button.each(function (){
            $(this).on('click', function (e){
                e.preventDefault();

                // Show all items when "Show More" is clicked
                items.removeClass('d-none').slideDown();
                // Hide the "Show More" button after all items are shown
                HideButton(button);
            })
        });
    }

    function DefaultFilters(){
        regionItemListDesktop.slice(0, 5).removeClass('d-none');
        regionItemListMobile.slice(0, 5).removeClass('d-none');
        typeItemListDesktop.slice(0, 5).removeClass('d-none');
        typeItemListMobile.slice(0, 5).removeClass('d-none');
        specialityItemListDesktop.slice(0, 5).removeClass('d-none');
        specialityItemListMobile.slice(0, 5).removeClass('d-none');


        NumberOfItemsInList(regionItemListDesktop,showMoreRegionsButton);
        NumberOfItemsInList(typeItemListDesktop,showMoreTypesButton);
        NumberOfItemsInList(specialityItemListDesktop,showMoreSpecialityButton);
    }

    function NumberOfItemsInList(list,button){
        if(list.length <= 5){
            HideButton(button);
        }
    }

    function HideButton(item){
        item.each(function(){
            $(this).hide();
        });
    }

}
